import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { HelmetProvider } from 'react-helmet-async';

// Import components
import Layout from './components/layout/Layout';
import ScrollToTop from './components/common/ScrollToTop';

// Import pages
import Home from './pages/Home';
import Browse from './pages/Browse';
import About from './pages/About';
import Speaker from './pages/Speaker';
import Contact from './pages/Contact';
import './styles/globals.css';

// Theme configuration
const theme = createTheme({
  palette: {
    primary: { main: '#d3d3d3' }, // light grey
    secondary: { main: '#dc004e' },
  },
  typography: {
    fontFamily: '"Newsreader", Georgia, "Times New Roman", serif',
    h1: {
      fontFamily: '"Manrope", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
      fontWeight: 800,
    },
    h2: {
      fontFamily: '"Manrope", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
      fontWeight: 700,
    },
    h3: {
      fontFamily: '"Manrope", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
      fontWeight: 700,
    },
    h4: {
      fontFamily: '"Manrope", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
      fontWeight: 600,
    },
    h5: {
      fontFamily: '"Manrope", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
      fontWeight: 500,
    },
    h6: {
      fontFamily: '"Manrope", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
      fontWeight: 500,
    },
    button: {
      fontFamily: '"Manrope", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
      fontWeight: 500,
      textTransform: 'none',
    },
    body1: {
      fontFamily: '"Newsreader", Georgia, "Times New Roman", serif',
      fontWeight: 400,
    },
    body2: {
      fontFamily: '"Newsreader", Georgia, "Times New Roman", serif',
      fontWeight: 400,
    },
  },
});

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <ScrollToTop />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/browse" element={<Browse />} />
              <Route path="/about" element={<About />} />
              <Route path="/speaker/:slug" element={<Speaker />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<div>Page Not Found</div>} />
            </Routes>
          </Layout>
        </Router>
      </ThemeProvider>
    </HelmetProvider>
  );
};

export default App; 